var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 0.75,
    y: 0.75,
    width: 46.5,
    height: 46.5,
    rx: 23.25,
    stroke: "white",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0849 14.1015C14.4754 13.711 15.1086 13.711 15.4991 14.1015L24.0001 22.6025L32.5012 14.1015C32.8917 13.711 33.5249 13.711 33.9154 14.1015C34.3059 14.492 34.3059 15.1252 33.9154 15.5157L25.4143 24.0167L33.883 32.4854C34.2736 32.876 34.2736 33.5091 33.883 33.8996C33.4925 34.2902 32.8594 34.2902 32.4688 33.8996L24.0001 25.4309L15.5314 33.8996C15.1409 34.2902 14.5077 34.2902 14.1172 33.8996C13.7267 33.5091 13.7267 32.876 14.1172 32.4854L22.5859 24.0167L14.0849 15.5157C13.6944 15.1252 13.6944 14.492 14.0849 14.1015Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.08262e46f8e2c24b273d41f198fbc744.svg";
export { ForwardRef as ReactComponent };